import { CSSProperties, FC, PropsWithChildren, ReactNode } from 'react';
import styled from 'styled-components';
import { Button, Flex } from 'antd';
import * as Icon from 'react-feather';
import { Detail, Padding, PopupView, TotalEntries } from '../common/components';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './ProcessingEventReport.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'processing-event-report',
);
addTranslations(translations);

interface ProcessingEventReportProps extends PropsWithChildren {
  title: string;
  downloadUrl?: string;
  meta?: {
    label?: string;
    value: ReactNode;
    style?: CSSProperties;
  }[];
  count?: number;
  isLoading?: boolean;
}

export const ProcessingEventReport: FC<ProcessingEventReportProps> = (
  props,
) => {
  const { title, downloadUrl, meta, count, isLoading, children } = props;
  const { t } = useTranslation();

  return (
    <PopupView
      title={t('error-report')}
      actions={
        <Button
          id="download-error-report"
          title={t('button.download')}
          icon={<Icon.Download size={18} />}
          href={downloadUrl}
        />
      }
      contentId="processing-error-report-main-content"
      footer={<TotalEntries count={count} />}
      isLoading={isLoading}
    >
      <Padding horizontal bottom>
        <Flex vertical gap="large">
          <h4>{title}</h4>
          {!!meta?.length && (
            <Columns>
              {meta.map(({ label, value, style }, index) => (
                <Detail key={index} label={label} style={style}>
                  {value}
                </Detail>
              ))}
            </Columns>
          )}
          {children}
        </Flex>
      </Padding>
    </PopupView>
  );
};

const Columns = styled.div`
  columns: 20em auto;
`;
